module.exports = __webpack_public_path__ + "img/uld-img-after.d4c783f0.svg";